var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 5.5L7.42687 8.76414C9.55068 9.9675 10.448 9.9675 12.5718 8.76414L18.3327 5.5",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67916 11.7296C1.73363 14.2843 1.76087 15.5615 2.70348 16.5078C3.64608 17.454 4.95796 17.4869 7.58171 17.5528C9.19877 17.5935 10.7999 17.5935 12.417 17.5528C15.0408 17.4869 16.3526 17.454 17.2953 16.5078C18.2379 15.5615 18.2651 14.2843 18.3195 11.7296C18.3371 10.9082 18.3371 10.0917 18.3195 9.27029C18.2651 6.71568 18.2379 5.43837 17.2953 4.49218C16.3526 3.54599 15.0408 3.51303 12.417 3.4471C10.7999 3.40647 9.19877 3.40647 7.5817 3.44709C4.95796 3.51301 3.64608 3.54597 2.70347 4.49217C1.76087 5.43836 1.73363 6.71567 1.67915 9.27029C1.66163 10.0917 1.66164 10.9082 1.67916 11.7296Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.97647ce3ade99a4779b0a77f3fdcb087.svg";
export { ForwardRef as ReactComponent };